import type { IntlShape } from 'react-intl'
import type { IPublicApiKeyRevocation, PublicApiKeyRevocationCode } from '@vacationtracker/shared/public-api/types'

const REVOCATION_MESSAGE: Record<PublicApiKeyRevocationCode, string> = {
  manual: 'publicApi.revocation.manual',
  owner_deactivated: 'publicApi.revocation.ownerDeactivated',
  owner_deleted: 'publicApi.revocation.ownerDeleted',
  owner_not_admin: 'publicApi.revocation.roleReduced',
  owner_location_admin_reduced: 'publicApi.revocation.roleReduced',
  owner_approver_reduced: 'publicApi.revocation.roleReduced',
  owner_permissions_reduced: 'publicApi.revocation.roleReduced',
  company_deleted: 'publicApi.revocation.companyDeleted',
}

export function formatRevocation(intl: Pick<IntlShape, 'formatMessage' | 'formatDate'>, revocation: IPublicApiKeyRevocation, ownerName: string): string {
  return intl.formatMessage({ id: REVOCATION_MESSAGE[revocation.code] }, { name: ownerName, date: intl.formatDate(revocation.revokedAt, { dateStyle: 'medium' }) })
}
